import React from "react";
import { useMediaQuery } from "react-responsive";

const SectionPdf = ({ slice }) => {
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;
  const isMobile = useMediaQuery({ maxWidth: 430 });
  const pdfUrl = "https://storage.googleapis.com/docs-media.encord.com/landing-page-docs/Rubric%20Evaluation%20-%20A%20Comprehensive%20Framework%20for%20Generative%20AI%20Assessment_.pdf";

  return (
    <div
      id="carouselTurner"
      className={`px-4 mx-auto mr-4 sm:mx-12 xl:mx-auto sm:px-0 lg:px-0 max-w-6xl ${!topSpacing || !bottomSpacing ? "py-10" : ""}  ${topSpacing === "80" && "sm:pt-20"} ${topSpacing === "40" && "sm:pt-10"} ${bottomSpacing === "80" && "sm:pb-20"} ${bottomSpacing === "40" && "sm:pb-10"}`}
    >
      <div className="rounded-2xl">
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          width="100%"
          height={isMobile ? "590px" : "780px"}
          style={{
            border: "2px solid #e5e7eb",
            borderRadius: "1rem",
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            maxHeight: "816px"
          }}
        />
      </div>
    </div>
  );
};

export default SectionPdf;
